import type { CommunityThreadContextType } from './communityThreadNotificationsService'

type CommunityThreadPresenceMessage =
  | {
      type: 'community_thread_presence'
      action: 'set'
      context_type: CommunityThreadContextType
      context_id: number
    }
  | {
      type: 'community_thread_presence'
      action: 'clear'
    }

function normalizeContextId(raw: number): number | null {
  const id = Number(raw)
  if (!Number.isFinite(id) || id <= 0) return null
  return Math.floor(id)
}

function postToServiceWorker(message: CommunityThreadPresenceMessage): void {
  if (typeof navigator === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  try {
    const sw = navigator.serviceWorker
    const controller = sw.controller
    if (controller) {
      controller.postMessage(message)
      return
    }

    // Best-effort: aguarda um pouco o SW assumir o controle (PWA/iOS pode precisar de um ciclo)
    let done = false
    const onCtrl = () => {
      if (done) return
      done = true
      try {
        sw.removeEventListener('controllerchange', onCtrl)
      } catch {
        // ignore
      }
      try {
        sw.controller?.postMessage(message)
      } catch {
        // ignore
      }
    }

    sw.addEventListener('controllerchange', onCtrl)
    setTimeout(() => {
      if (done) return
      done = true
      try {
        sw.removeEventListener('controllerchange', onCtrl)
      } catch {
        // ignore
      }
    }, 2000)
  } catch {
    // ignore (best-effort)
  }
}

export function setCommunityThreadPresence(params: {
  contextType: CommunityThreadContextType
  contextId: number
}): void {
  const id = normalizeContextId(params.contextId)
  if (!id) return
  postToServiceWorker({
    type: 'community_thread_presence',
    action: 'set',
    context_type: params.contextType,
    context_id: id,
  })
}

export function clearCommunityThreadPresence(): void {
  postToServiceWorker({ type: 'community_thread_presence', action: 'clear' })
}
